/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */
import Bus from "@/lobby_common/utils/bus.js";
export function googleAuth(CLIENT_ID, API_KEY) {
  console.log("googleAuth", CLIENT_ID, API_KEY);
  /* exported gapiLoaded */
  /* exported gisLoaded */
  /* exported handleAuthClick */
  /* exported handleSignoutClick */

  // TODO(developer): Set to client ID and API key from the Developer Console

  if (!CLIENT_ID || !API_KEY) {
    return;
  }

  // google授权登陆流程文档
  // https://developers.google.com/drive/api/quickstart/js?hl=zh-cn

  // Authorization scopes required by the API; multiple scopes can be
  // included, separated by spaces.
  const SCOPES =
    "email profile openid https://www.googleapis.com/auth/drive.metadata.readonly https://www.googleapis.com/auth/admin.directory.customer.readonly https://www.googleapis.com/auth/userinfo.email https://www.googleapis.com/auth/userinfo.profile https://www.googleapis.com/auth/calendar.readonly";
  let tokenClient;

  /**
   * Callback after Google Identity Services are loaded.
   */
  function gisLoaded() {
    console.log("function gisLoaded");
    tokenClient = google.accounts.oauth2.initTokenClient({
      client_id: CLIENT_ID,
      scope: SCOPES,
      ux_mode: "popup",
      callback: "", // defined later
    });
  }

  window.gisLoaded = gisLoaded;

  /**
   *  Sign in the user upon button click.
   */
  function handleAuthClick(callbackFun) {
    console.log("function handleAuthClick");
    tokenClient.callback = async (resp) => {
      if (resp.error !== undefined) {
        throw resp;
      }
      callbackFun(resp);
      console.log("resp", resp);
    };
    tokenClient.requestAccessToken();
  }

  Bus.$on("googleAuthClick", function (callbackFun) {
    console.log("googleAuthClick");
    handleAuthClick(callbackFun);
  });

  // <button id="authorize_button" onclick="handleAuthClick()">Authorize</button>
  // <button id="signout_button" onclick="handleSignoutClick()">Sign Out</button>
  // <script async defer src="https://apis.google.com/js/api.js" onload="gapiLoaded()"></script>
  // <script async defer src="https://accounts.google.com/gsi/client" onload="gisLoaded()"></script>
}
